<template>
  <WebChapterTemplate
    :page-title="pageTitle"
    :section-label="sectionLabel"
    :section-route="sectionRoute"
    :top-strip-image="topStripImage"
    :hero-background-image="heroBackgroundImage"
  >
    <div class="chapter-manual">
      <section
        v-for="section in sections"
        :key="section.title"
        class="chapter-section"
      >
        <div class="chapter-section__header">
          <h2 class="chapter-section__title">{{ section.title }}</h2>
          <template v-if="normalizeText(section.summary).length">
            <p
              v-for="paragraph in normalizeText(section.summary)"
              :key="`${section.title}-${paragraph}`"
              class="chapter-section__summary"
            >
              {{ paragraph }}
            </p>
          </template>
        </div>

        <div
          class="chapter-grid"
          :class="`chapter-grid--${section.columns || 2}`"
        >
          <article
            v-for="card in section.cards"
            :key="card.title"
            class="chapter-card"
          >
            <figure class="chapter-card__figure">
              <img :src="card.src" :alt="card.title" loading="lazy" />
            </figure>
            <div class="chapter-card__body">
              <h3 class="chapter-card__title">{{ card.title }}</h3>
              <template v-for="paragraph in normalizeText(card.description)">
                <p
                  :key="`${card.title}-${paragraph}`"
                  class="chapter-card__text"
                >
                  {{ paragraph }}
                </p>
              </template>
            </div>
          </article>
        </div>
      </section>
    </div>
  </WebChapterTemplate>
</template>

<script>
import WebChapterTemplate from '@/components/WebChapterTemplate.vue';

export default {
  name: 'AcademicCardsChapter',
  components: {
    WebChapterTemplate
  },
  props: {
    pageTitle: { type: String, required: true },
    sectionLabel: { type: String, default: '学科建设' },
    sectionRoute: { type: [String, Object], required: true },
    topStripImage: { type: String, required: true },
    heroBackgroundImage: { type: String, required: true },
    sections: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    normalizeText(value) {
      if (!value) return [];
      return Array.isArray(value) ? value : [value];
    }
  }
};
</script>

<style scoped>
.chapter-manual {
  display: grid;
  gap: 32px;
}

.chapter-section {
  padding: 26px;
  border-radius: 12px;
  border: 1px solid rgba(179, 145, 101, 0.18);
  background:
    linear-gradient(140deg, rgba(248, 242, 233, 0.84), rgba(255, 255, 255, 0) 42%),
    linear-gradient(180deg, #fff, rgba(253, 250, 246, 0.96));
  box-shadow: 0 14px 30px rgba(59, 41, 17, 0.05);
}

.chapter-section__header {
  margin-bottom: 24px;
  padding-bottom: 14px;
  border-bottom: 1px solid rgba(179, 145, 101, 0.16);
}

.chapter-section__title {
  margin: 0;
  color: #f25c19;
  font-size: 26px;
  line-height: 1.4;
  font-family: 'Songti SC', 'STSong', 'Noto Serif SC', serif;
  font-weight: 700;
}

.chapter-section__summary {
  margin: 10px 0 0;
  color: #6b5b4b;
  font-size: 16px;
  line-height: 1.8;
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

.chapter-grid {
  display: grid;
  gap: 20px;
}

.chapter-grid--2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.chapter-grid--3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.chapter-card {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 12px;
  border: 1px solid rgba(179, 145, 101, 0.16);
  background: #fff;
  box-shadow: 0 10px 24px rgba(45, 33, 16, 0.05);
}

.chapter-card__figure {
  margin: 0;
  background: #f8f4ee;
}

.chapter-card__figure img {
  display: block;
  width: 100%;
  height: auto;
}

.chapter-card__body {
  padding: 18px 18px 20px;
}

.chapter-card__title {
  margin: 0 0 8px;
  color: #2f2a25;
  font-size: 20px;
  line-height: 1.5;
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
  font-weight: 600;
}

.chapter-card__text {
  margin: 0;
  color: #4c433a;
  font-size: 17px;
  line-height: 1.9;
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

.chapter-card__text + .chapter-card__text {
  margin-top: 8px;
}

@media (max-width: 1200px) {
  .chapter-grid--3 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 1024px) {
  .chapter-grid--2,
  .chapter-grid--3 {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .chapter-section {
    padding: 18px;
  }

  .chapter-section__title {
    font-size: 24px;
  }

  .chapter-card__title {
    font-size: 18px;
  }

  .chapter-card__text,
  .chapter-section__summary {
    font-size: 16px;
    line-height: 1.8;
  }
}
</style>
